"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageContentType = exports.MessageContent = void 0;
var MessageContent;
(function (MessageContent) {
    let Message;
    (function (Message) {
        Message.Type = {
            Text: 'text',
            Upload: 'upload',
            RateForm: 'rate_form',
        };
    })(Message = MessageContent.Message || (MessageContent.Message = {}));
    let Event;
    (function (Event) {
        Event.Type = {
            AgentJoin: 'agent_join',
            AgentAssign: 'agent_assign',
            AgentUnassign: 'agent_unassign',
            AgentLeave: 'agent_leave',
            ChatClose: 'chat_close',
            ChatVisitorClose: 'chat_visitor_close',
            ChatTransfer: 'chat_transfer',
        };
    })(Event = MessageContent.Event || (MessageContent.Event = {}));
    let Help;
    (function (Help) {
        Help.Type = {
            Text: 'text',
            FoundEmail: 'found_email',
        };
    })(Help = MessageContent.Help || (MessageContent.Help = {}));
})(MessageContent = exports.MessageContent || (exports.MessageContent = {}));
exports.MessageContentType = {
    ...MessageContent.Message.Type,
    ...MessageContent.Event.Type,
    ...MessageContent.Help.Type,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVzc2FnZS1jb250ZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL21lc3NhZ2UtY29udGVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFVQSxJQUFpQixjQUFjLENBeUo5QjtBQXpKRCxXQUFpQixjQUFjO0lBTzlCLElBQWlCLE9BQU8sQ0FrQ3ZCO0lBbENELFdBQWlCLE9BQU87UUFDVixZQUFJLEdBQUc7WUFDbkIsSUFBSSxFQUFFLE1BQU07WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixRQUFRLEVBQUUsV0FBVztTQUNaLENBQUE7SUE2QlgsQ0FBQyxFQWxDZ0IsT0FBTyxHQUFQLHNCQUFPLEtBQVAsc0JBQU8sUUFrQ3ZCO0lBWUQsSUFBaUIsS0FBSyxDQW9FckI7SUFwRUQsV0FBaUIsS0FBSztRQUNSLFVBQUksR0FBRztZQUNuQixTQUFTLEVBQUUsWUFBWTtZQUN2QixXQUFXLEVBQUUsY0FBYztZQUMzQixhQUFhLEVBQUUsZ0JBQWdCO1lBQy9CLFVBQVUsRUFBRSxhQUFhO1lBQ3pCLFNBQVMsRUFBRSxZQUFZO1lBQ3ZCLGdCQUFnQixFQUFFLG9CQUFvQjtZQUN0QyxZQUFZLEVBQUUsZUFBZTtTQUNwQixDQUFBO0lBMkRYLENBQUMsRUFwRWdCLEtBQUssR0FBTCxvQkFBSyxLQUFMLG9CQUFLLFFBb0VyQjtJQU9ELElBQWlCLElBQUksQ0F3QnBCO0lBeEJELFdBQWlCLElBQUk7UUFDUCxTQUFJLEdBQUc7WUFDbkIsSUFBSSxFQUFFLE1BQU07WUFDWixVQUFVLEVBQUUsYUFBYTtTQUNoQixDQUFBO0lBb0JYLENBQUMsRUF4QmdCLElBQUksR0FBSixtQkFBSSxLQUFKLG1CQUFJLFFBd0JwQjtBQUNGLENBQUMsRUF6SmdCLGNBQWMsR0FBZCxzQkFBYyxLQUFkLHNCQUFjLFFBeUo5QjtBQU9ZLFFBQUEsa0JBQWtCLEdBQUc7SUFDakMsR0FBRyxjQUFjLENBQUMsT0FBTyxDQUFDLElBQUk7SUFDOUIsR0FBRyxjQUFjLENBQUMsS0FBSyxDQUFDLElBQUk7SUFDNUIsR0FBRyxjQUFjLENBQUMsSUFBSSxDQUFDLElBQUk7Q0FDbEIsQ0FBQSJ9